import React from 'react';

export interface OverwriteConfirmModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  /** issue #146: 上書き対象のファイル名 (.omfz 拡張子は呼び出し側で除去済み)。 */
  fileName?: string;
}

const OverwriteConfirmModal: React.FC<OverwriteConfirmModalProps> = ({ isOpen, onConfirm, onCancel, fileName }) => {
  if (!isOpen) return null;
  return (
    <div role="dialog" aria-modal="true" aria-label="上書き確認"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4">
        <h2 className="text-lg font-bold mb-3">現在の編集内容を上書きしますか?</h2>
        {fileName && (
          <p className="text-sm font-bold text-slate-800 mb-2 break-words">「{fileName}」</p>
        )}
        <p className="text-sm text-slate-600 mb-5">
          履歴から復元すると、 現在編集中の運指データは失われます。
        </p>
        <div className="flex gap-3 justify-end">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-100">
            キャンセル
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className="px-4 py-2 rounded-lg bg-amber-500 text-white hover:bg-amber-600">
            復元する
          </button>
        </div>
      </div>
    </div>
  );
};

export default OverwriteConfirmModal;
